<template>
    <tbody>
        <tr 
            v-for="(permit, index) in extendedActs"
            :key="permit.POSTOPEK_EGR_STEVILKA_ZADEVE"
        >
            <td class="text-center">
                {{ re_key }}
            </td>
            <td class="text-center">
                <k-editable
                    v-if="editable"
                    v-model="permit.POSTOPEK_EGR_STEVILKA_ZADEVE"
                    default-if-none="/"
                    @close="$emit('save', permit)">
                </k-editable>
                <span v-else>{{permit.POSTOPEK_EGR_STEVILKA_ZADEVE}}</span>
            </td>
            <td class="text-center">
                <k-editable
                    v-if="editable"
                    v-model="permit.ORGAN_VLOZITVE_EGR_POLNI_NAZIV"
                    default-if-none="/"
                    @close="$emit('save', permit)">
                </k-editable>
                <span v-else>{{permit.ORGAN_VLOZITVE_EGR_POLNI_NAZIV}}</span>
            </td>
            <td class="text-center">
                <k-editable
                    v-if="editable"
                    v-model="permit.POSTOPEK_EGR_ID"
                    default-if-none="/"
                    @close="$emit('save', permit)">
                </k-editable>
                <span v-else>{{permit.POSTOPEK_EGR_ID}}</span>
            </td>
            <td class="text-center">
                <k-editable
                    v-if="editable"
                    v-model="permit.VRSTA_UA_NAZIV"
                    default-if-none="/"
                    @close="$emit('save', permit)">
                </k-editable>
                <span v-else>{{permit.VRSTA_UA_NAZIV}}</span>
            </td>
            <td class="text-center">
                <k-editable
                    v-if="editable"
                    v-model="permit.DATUM_POPOLNOSTI"
                    default-if-none="/"
                    @close="$emit('save', permit)">
                </k-editable>
                <span v-else>{{permit.DATUM_POPOLNOSTI}}</span>
            </td>
            <td class="text-center">
                <k-editable
                    v-if="editable"
                    v-model="permit.DATUM_PRAVNOMOCNOSTI"
                    default-if-none="/"
                    @close="$emit('save', permit)">
                </k-editable>
                <span v-else>{{permit.DATUM_PRAVNOMOCNOSTI}}</span>
            </td>
            <td class="text-center" v-if="editable">
                <span v-tooltip="$t('aa:tooltip:remove_from_access')" 
                    class="btn btn-xs btn-outline btn-rounded btn-danger m-b-10"
                    v-on:click.prevent="$emit('remove', index)">
                        {{$t('general:remove')}}
                </span>
            </td>
        </tr>
    </tbody>
</template>

<script>
import KEditable from "@/components/k-editable/KEditable";

export default {
    props: {
        acts: {
            type: Array,
            default: () => []
        },
        editable: {
            type: Boolean,
            default: true,
        },
        re_key: {
            type: String,
            required: true,
        },
    },
    components: {
        KEditable
    },
    data() {
        return {
            extendedActs: [],
        }
    },
    mounted() {
        this.extendedActs = this.acts.map(act => {
            return {
                ...act,
                showMore: false,
            };
        });
    },
    methods: {
        nonBreakableReKey(re_key) {
            // replace - with non breakable hyphen and / with non breakable slash
            return re_key.replace(/-/g, '-\u00AD').replace(/\//g, '/\u00AD');
        },
    },
}
</script>

<style scoped>
.border-top {
    border-top-width: 2px;
}
.upper {
    text-transform: uppercase;
}
.no-wrap {
    white-space: nowrap;
}
</style>
